// extracted by mini-css-extract-plugin
export default {"wrap":"CookieNotice_wrap__L1s4N","text":"CookieNotice_text__oPpWt","button":"CookieNotice_button__cpq95"};